/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import Spinner from '@atlaskit/spinner';
var loadingStyles = css({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden'
});
export var Loading = function Loading(_ref) {
  var _ref$dimensions = _ref.dimensions,
    _ref$dimensions2 = _ref$dimensions === void 0 ? {} : _ref$dimensions,
    width = _ref$dimensions2.width,
    height = _ref$dimensions2.height;
  return jsx("span", {
    "data-testid": 'media-svg-loading',
    role: "status",
    css: loadingStyles
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: {
      width: width,
      height: height
    }
  }, jsx(Spinner, null));
};